import * as Yup from 'yup';
import type { IncidentReportYesNoOther } from 'components/CriticalIncident/interfaces';
import { yesNoOther, requiredWhenIs } from '../utils';

export const initialValues = {
    preparationMeetingWithContact: '' as IncidentReportYesNoOther,
    preparationMeetingWithContactOtherReason: '',
    wereEmployeesAwareAndEngaged: '' as IncidentReportYesNoOther,
    wereEmployeesAwareAndEngagedOtherReason: '',
    wereReferralsExtended: '' as IncidentReportYesNoOther,
    wereReferralsExtendedOtherReason: '',
    noOfWalkAbouts: 0,
    walkAboutDescription: '',
    noOfOutreachRequests: 0,
    outreachDescription: '',
    noOfConsultations: 0,
    consultationDescription: '',
};

const requiredIfGreaterThanZero = () => ({
        is: (value: number) => value > 0,
        then: (schema:  Yup.StringSchema<string | undefined, Yup.AnyObject, undefined, "">) => schema.required('error_required_field'),
    });

export const validationSchema = Yup.object({
    preparationMeetingWithContact: yesNoOther.notRequired(),
    preparationMeetingWithContactOtherReason: Yup.string().when('preparationMeetingWithContact', requiredWhenIs('O')),
    wereEmployeesAwareAndEngaged: yesNoOther.required('error_required_field'),
    wereEmployeesAwareAndEngagedOtherReason: Yup.string().when('wereEmployeesAwareAndEngaged', requiredWhenIs('O')),
    wereReferralsExtended: yesNoOther.required('error_required_field'),
    wereReferralsExtendedOtherReason: Yup.string().when('wereReferralsExtended', requiredWhenIs('O')),
    noOfWalkAbouts: Yup.number().integer().min(0).required('error_required_field'),
    walkAboutDescription: Yup.string().when('noOfWalkAbouts', requiredIfGreaterThanZero()),
    noOfOutreachRequests: Yup.number().integer().min(0).required('error_required_field'),
    outreachDescription: Yup.string().when('noOfOutreachRequests', requiredIfGreaterThanZero()),
    noOfConsultations: Yup.number().integer().min(0).required('error_required_field'),
    consultationDescription: Yup.string().when('noOfConsultations', requiredIfGreaterThanZero()),
});
